import {
  AlertCircle,
  Copy,
  ChevronDown,
  ChevronUp,
} from "lucide-react";
import { useState } from "react";

interface ErrorStateProps {
  error: any;
  reset: () => void;
  textButton?: string;
}

const ErrorState = ({
  error,
  reset,
  textButton = "Try Again",
}: ErrorStateProps) => {
  const [showDetail, setShowDetail] = useState(false);

  // สกัดเอา Message ออกมาให้ดูง่าย
  const errorMessage =
    error?.message || error?.toString() || "An unexpected error occurred.";
  const errorStack =
    error?.stack || "No additional technical details available.";

  return (
    <div className="flex flex-col items-center justify-center p-6 text-center">
      {/* 1. Visual Icon */}
      <div className="mb-4 rounded-full bg-red-50 p-4 text-red-500">
        <AlertCircle size={48} />
      </div>

      {/* 2. Headline & Description */}
      <h3 className="mb-2 text-xl font-semibold text-gray-900">
        Something went wrong
      </h3>
      <p className="mb-6 text-sm text-gray-500 max-w-[280px]">{errorMessage}</p>

      {/* 3. Main Action */}
      <button
        onClick={reset}
        className="text-sm font-semibold text-gray-600 underline decoration-gray-300 underline-offset-4 hover:text-gray-900 hover:decoration-gray-900 transition-all duration-200"
      >
        {textButton}
      </button>

      {/* 4. Technical Details (Collapsible) - สำหรับ UX ของสาย Dev/Support */}
      <div className="mt-6 w-full border-t pt-4">
        <button
          onClick={() => setShowDetail(!showDetail)}
          className="flex w-full items-center justify-between text-xs font-medium text-gray-400 hover:text-gray-600"
        >
          TECHNICAL DETAILS
          {showDetail ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </button>

        {showDetail && (
          <div className="mt-3 text-left">
            <pre className="max-h-32 overflow-auto rounded bg-gray-50 p-3 text-[10px] text-gray-600 font-mono border">
              {errorStack}
            </pre>
            <button
              onClick={() => navigator.clipboard.writeText(errorStack)}
              className="mt-2 flex items-center gap-1 text-[10px] text-blue-500 hover:underline"
            >
              <Copy size={12} /> Copy error log
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
